import { Button, Stack } from "@mui/material";
import { type CSSProperties, Fragment, useState } from "react";
import { UploadImageModal } from "./upload-image-modal";
import { ResponsiveImage } from "./responsive-image";
import { PaperCard } from "./paper-card";
import { type ImageConstraints } from "./image-upload-common";

type Props = {
  disabled?: boolean;
  src: string;
  constraints: ImageConstraints;
  onUpload: (file: File) => Promise<boolean>;
  imgStyle?: CSSProperties;
  isError?: boolean;
};

export const ImageUpload = ({
  disabled,
  src,
  onUpload,
  constraints,
  imgStyle,
  isError,
}: Props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleUpload = async (file: File) => {
    setLoading(true);

    const isSuccess = await onUpload(file);

    setLoading(false);

    if (isSuccess) {
      setOpen(false);
    }
  };

  const borderColor = isError ? "red" : "#D4D5D3";

  return (
    <Fragment>
      <PaperCard
        sx={{
          height: "100%",
          p: 2,
          border: `1px solid ${borderColor}`,
          boxShadow: "none",
        }}
      >
        <Stack justifyContent={"space-between"} sx={{ height: "100%" }}>
          <ResponsiveImage
            src={src}
            style={{
              aspectRatio: 470 / 260,
              maxHeight: "260px",
              objectFit: "contain",
              marginBottom: "8px",
              ...imgStyle,
            }}
          />

          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen(true)}
            fullWidth
            disabled={disabled}
          >
            Upload Logo
          </Button>
        </Stack>
      </PaperCard>

      <UploadImageModal
        open={open}
        onClose={() => setOpen(false)}
        constraints={constraints}
        allowedFileTypes={["image/webp", ".webp"]}
        handleUpload={handleUpload}
        uploading={loading}
      />
    </Fragment>
  );
};
